/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャットメッセージ関連の定数クラス
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */

export default class {
  /**
   * メッセージタイプ : チャット開始
   */
  static get MESSAGE_TYPE_CHAT_START() {
    return 'chatStart'
  }
  /**
   * メッセージタイプ : メッセージ追加
   */
  static get MESSAGE_TYPE_ADD_MESSAGE() {
    return 'addMessage'
  }
  /**
   * メッセージタイプ : システムエラー
   */
  static get MESSAGE_TYPE_SYSTEM_ERROR() {
    return 'systemError'
  }
  /**
   * メッセージタイプ : ファイル送信エラー
   */
  static get MESSAGE_TYPE_SEND_FILE_ERROR() {
    return 'sendFileError'
  }
  /**
   * メッセージタイプ : チャット終了
   */
  static get MESSAGE_TYPE_CHAT_END() {
    return 'chatEnd'
  }
  /**
   * メッセージタイプ : チャット接続初期化
   */
  static get INIT_CHAT_CONNECTION() {
    return 'initChatConnection'
  }
  /**
   * メッセージタイプ : チャット接続初期化済み
   */
  static get INITIALIZED_CHAT_CONNECTION() {
    return 'initializedChatConnection'
  }
  /**
   * FastChatサービス状態 : 営業時間外
   */
  static get FASTCHAT_SERVICE_STATUS_QUIET_HOURS() {
    return 'quietHours'
  }
  /**
   * メッセージタイプ : メッセージ入力中
   */
  static get MESSAGE_TYPE_FH_TYPING() {
    return 'fhTyping'
  }
  /**
   * メッセージタイプ : ユーザ認証失敗
   */
  static get USER_CERTIFICATE_FAILED() {
    return 'userCertificateFailed'
  }
  /**
   * メッセージタイプ : チャット終了(session変更)
   */
  static get MESSAGE_TYPE_CHAT_END_BY_SESSION_CHANGE() {
    return 'chatEndBySessionChange'
  }
  /**
   * メッセージタイプ : サジェスト
   */
  static get MESSAGE_TYPE_SUGGEST() {
    return 'suggest'
  }
  /**
   * メッセージタイプ : マイページ開始エラー
   */
  static get MESSAGE_TYPE_MYPAGE_START_FAILED() {
    return 'myPageStartFailed'
  }
  /**
   * メッセージ種別(FastChat→FastHelp) : チャット開始
   */
  static get MESSAGE_EVENT_TYPE_CHAT_START() {
    return 'chatStart'
  }
  /**
   * メッセージ種別(FastChat→FastHelp) : チャット終了
   */
  static get MESSAGE_EVENT_TYPE_CHAT_END() {
    return 'chatEnd'
  }
  /**
   * メッセージ種別(FastChat→FastHelp) : メッセージ送信
   */
  static get MESSAGE_EVENT_TYPE_SEND_MESSAGE() {
    return 'sendMessage'
  }
  /**
   * メッセージ種別(FastChat→FastHelp) : ファイル送信
   */
  static get MESSAGE_EVENT_TYPE_SEND_FILE() {
    return 'sendFile'
  }
  /**
   * メッセージ種別(FastChat→FastHelp) : 再接続
   */
  static get MESSAGE_EVENT_TYPE_CHAT_RECONNECT() {
    return 'chatReconnect'
  }
  /**
   * メッセージ種別(FastChat→FastHelp) : 入力中
   */
  static get MESSAGE_EVENT_TYPE_MESSAGE_TYPING() {
    return 'messageTyping'
  }
  /**
   * メッセージ種別(FastChat→FastHelp) : サジェスト
   */
  static get MESSAGE_EVENT_TYPE_SUGGESTIONS() {
    return 'suggestions'
  }
  /**
   * 応対モード : attachDownload
   */
  static get MESSAGE_EVENT_TYPE_ATTACH_DOWNLOAD() {
    return 'attachDownload'
  }
  /**
   * 応対モード : undoSendAttach
   */
  static get MESSAGE_EVENT_TYPE_UNDO_SEND_ATTACH() {
    return 'undoSendAttach'
  }
  /**
   * メッセージタイプ : 担当者既読
   */
  static get MESSAGE_TYPE_CHAT_STAFF_READED() {
    return 'chatStaffReaded'
  }
  /**
   * メッセージタイプ : チャットタイムアウト
   */
  static get MESSAGE_TYPE_CHAT_TIMEOUT() {
    return 'chatTimeout'
  }
  /**
   * 応対モード : auto
   */
  static get RECEPTION_MODE_AUTO() {
    return 'auto'
  }
  /**
   * 応対モード : manual
   */
  static get RECEPTION_MODE_MANUAL() {
    return 'manual'
  }
  /**
   * BOT状態 BOT回答待ち
   */
  static get BOT_STATUS_WAIT() {
    return '1'
  }
}



// WEBPACK FOOTER //
// ./src/constants/ChatMessageConst.js